var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        bus: _vm.busModal,
        centerScreen: "",
        centerAndDecreasesPadding: "",
        maxWidth: "500px",
        closeColor: "#8e8e8e",
        backgroundColor: "white",
        "content-class": "consolidator-select-client-modal"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6 consolidator-select-client" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v(" Selecionar cliente ")
          ])
        ]),
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c("p", { staticClass: "text-sm text-color-900 mb-4" }, [
              _vm._v(" Selecione o cliente para visualizar a carteira dele. ")
            ]),
            _c("ClientSearch", {
              staticClass: "new-ux",
              attrs: { outlined: "" }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }